import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, PLATFORM_ID } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';

import { CookieConsentComponent } from '@usheru-hff/hff-common/feature-cookie-consent';
import { ModalPictureComponent } from '@usheru-hff/hff-common/feature-modal-picture';
import { FooterComponent } from '@usheru-hff/core/footer';
import { HffCommonUiGoToTopModule } from '@usheru-hff/hff-common/ui-go-to-top';
import { HffCommonUiHeaderModule } from '@usheru-hff/hff-common/ui-header';
import { VideoFullscreenComponent } from '@usheru-hff/hff-common/ui-video-fullscreen';
import { addBrandedRoute } from '@usheru-hff/hff-common/util-routes';
import { VideoFullscreenService } from '@usheru-hff/shared/ui-video';
import { ModalPictureService, SharedUtilsModule, timerIfClient$ } from '@usheru-hff/shared/utils';
import { NgProgressModule } from 'ngx-progressbar';
import { ModalService } from '@usheru-hff/shared/utils-modal';
import { UiModalDialogComponent } from '@usheru-hff/shared/ui-modal-dialog';

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  imports: [
    CommonModule,
    RouterOutlet,
    HffCommonUiHeaderModule,
    FooterComponent,
    VideoFullscreenComponent,
    ModalPictureComponent,
    CookieConsentComponent,
    HffCommonUiGoToTopModule,
    SharedUtilsModule,
    NgProgressModule,
    UiModalDialogComponent
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-progress />
    <!-- Check NgProgressModule import and the NgProgressRouterModule in the providers -->
    <!-- -->
    <div class="page-wrapper" appPageWrapper>
      <ush-header />
      <div class="page-content-wrapper">
        <router-outlet></router-outlet>
      </div>
      @defer (on viewport; when deferFooter$ | async) {
        <ush-footer id="main-footer"></ush-footer>
      } @placeholder {
        <div class="footer-container"></div>
      }
      <!-- Necesary For HFF applications -->
      @defer (when modalPictureNeeded$ | async) {
        <ush-modal-picture></ush-modal-picture>
      } @placeholder {
        <div></div>
      }

      @defer (when modelDialogNeeded$ | async) {
        <ush-ui-modal-dialog></ush-ui-modal-dialog>
      } @placeholder {
        <div></div>
      }
      @defer (when videoFullscreenNeeded$ | async) {
        <ush-video-fullscreen></ush-video-fullscreen>
      } @placeholder {
        <div></div>
      }
      @defer (on idle) {
        <ush-cookie-consent></ush-cookie-consent>
      } @placeholder {
        <div></div>
      }
    </div>
  `
})
export class AppComponent {
  private readonly modalPictureService = inject(ModalPictureService);
  private readonly videoFullScreenService = inject(VideoFullscreenService);
  private readonly isPlatformBrowser: boolean = isPlatformBrowser(inject(PLATFORM_ID));
  private readonly modalService = inject(ModalService);

  modelDialogNeeded$ = this.modalService.showModal$;
  modalPictureNeeded$ = this.modalPictureService.image;
  videoFullscreenNeeded$ = this.videoFullScreenService.content$;
  deferFooter$: Observable<boolean> = timerIfClient$(3000, this.isPlatformBrowser);
}
